import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { me as apiMe, login as apiLogin, logout as apiLogout } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, obj = auth'd
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const u = await apiMe();
      setUser(u);
    } catch {
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const u = await apiLogin(email, password);
    setUser({ id: u.id, email: u.email, name: u.name, role: u.role });
    return u;
  };

  const logout = async () => {
    try { await apiLogout(); } catch (_) {}
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
